import { render, staticRenderFns } from "./field-total.vue?vue&type=template&id=2cde4774&scoped=true&"
import script from "./field-total.vue?vue&type=script&lang=js&"
export * from "./field-total.vue?vue&type=script&lang=js&"
import style0 from "./field-total.vue?vue&type=style&index=0&id=2cde4774&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cde4774",
  null
  
)

export default component.exports